import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  JobPositionTypeEnum,
  JOB_POSITION_TYPE_DISPLAY
} from '@umss/shared/data-access';
import { UmssBadgeComponent } from '../badge/badge.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

/**
 * Component to display a badge based on job position type.
 * Shows position type (e.g., "PartTime") with a tooltip showing the full name (e.g., "Part Time").
 */
@Component({
  selector: 'umss-job-position-type-badge',
  standalone: true,
  imports: [UmssBadgeComponent, UmssTooltipDirective],
  template: `
    @if (positionType) {
      <umss-badge
        [variant]="'secondary'"
        [label]="label"
        [outlined]="true"
        [umssTooltip]="displayText"
        tooltipPosition="top"
        [size]="size"
      />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssJobPositionTypeBadgeComponent {
  private _positionType: string = '';
  displayText: string = '';

  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input({ required: true }) set positionType(
    value: string | JobPositionTypeEnum
  ) {
    this._positionType = value as string;

    this.displayText =
      JOB_POSITION_TYPE_DISPLAY[value as JobPositionTypeEnum] || value;
  }
  get positionType(): string {
    return this._positionType;
  }

  get label(): string {
    return this.displayText || this._positionType || '';
  }
}
